import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StudijnyPlanItem} from '../model/StudijnyPlanItem';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import {delay} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {VyberJazykaComponent} from '../vyber-jazyka/vyber-jazyka.component';
import {Predmet} from '../model/predmet';

@Component({
    selector: 'app-studijny-plan-item',
    templateUrl: './studijny-plan-item.component.html',
    styleUrls: ['./studijny-plan-item.component.css'],
    standalone: false
})
export class StudijnyPlanItemComponent implements OnInit {

  @Input() predmet: StudijnyPlanItem;
  @Output() saved = new EventEmitter<boolean>();
  light: boolean;
  detail: Predmet;

  panelOpenState = false;

  constructor(
    private http: HttpClient,
    private appService: AppService,
    private translation: TranslateService,
    private dialogService: MatDialog
  ) { }

  ngOnInit(): void { }

  onClick($event)
  {
    $event.stopPropagation();

    this.light = true;

    if (this.predmet.jazyk && this.predmet.jazyk.length > 1) {

      const dialogRef = this.dialogService.open(
        VyberJazykaComponent, {
          data: {
            predmet: this.predmet
          }
        });

      dialogRef.afterClosed().subscribe(result => {
        this.zapisPredmet(this.predmet, result);
      });

    }
    else {
      this.zapisPredmet(this.predmet, this.predmet.jazyk ? this.predmet.jazyk[0] : 'SK');
    }
  }

  private zapisPredmet(predmet: StudijnyPlanItem, jazyk: string)
  {
    this.predmet.jazyk = [jazyk];

    this.http.post<StudijnyPlanItem>(
        '/ais/rest/portal/student-predmety/zapis', this.predmet
    )
        .pipe(delay(250))
        .subscribe({
            next: () => {
                this.appService.openSnackBar(
                    this.translation.instant('Predmet bol zapísaný do zápisného listu.')
                );
                this.appService.fetchPredmety();
                this.saved.emit(true);
            },
            error:  (error) => {
                this.appService.openErrorDialog(error.error.message);
            }
        });
  }

  onAfterExpand() {
    if (!this.detail) {
      this.http.get<Predmet>('/ais/rest/portal/student-predmety/predmet/' + this.predmet.idPredmetRok + '/v2')
        .subscribe(
          predmet => this.detail = predmet,
          error => console.error(error)
        );
    }
  }

  getRocnik(predmet: StudijnyPlanItem): string {
    if (predmet.rocnik !== null) {
      return predmet.rocnik + '.r';
    }
    return '';
  }

  getPredmetInfoMobile(predmet: StudijnyPlanItem): string {
    const out = [];

    if (predmet.semester) {
      out.push(predmet.semester + 'S');
    }

    if (predmet.rozsah) {
      out.push(predmet.rozsah);
    }

    if (predmet.rocnik) {
      out.push(predmet.rocnik + '.r');
    }

    if (predmet.kredit) {
      out.push(predmet.kredit + this.translation.instant('kreditSkratka'));
    }

    return out.join('; ');
  }
}
